import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    width: 14.2857%;
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: ${displayState?.dateMarginTop ?? '20px'};
      
    
    background: ${displayState?.inSelectedPeriod ? `${theme?.colour?.primary ?? '#1DBD6B'}20` : ''};

    ${displayState?.roundedRight && css`
      background: linear-gradient(${`${theme?.colour?.primary ?? '#1DBD6B'}20`},${`${theme?.colour?.primary ?? '#1DBD6B'}20`}) left/ 50% 100% no-repeat;
    `};

    ${displayState?.roundedLeft && css`
      background: linear-gradient(${`${theme?.colour?.primary ?? '#1DBD6B'}20`},${`${theme?.colour?.primary ?? '#1DBD6B'}20`}) right/ 50% 100% no-repeat;
    `};

    ${displayState?.roundedLeft && displayState?.roundedRight && css`
      background: unset;
    `};
  `}
`;

export default Wrapper(template);
